"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLocaleCategoryPrefix = getLocaleCategoryPrefix;
exports.getLocaleTagPrefix = getLocaleTagPrefix;
exports.getLocaleGamePrefix = getLocaleGamePrefix;
exports.getLocaleDomainDetails = getLocaleDomainDetails;
exports.getLocaleDomain = getLocaleDomain;
const isDefined_1 = require("@crazygames/utils/isDefined");
const localeToCategoryPrefix = {
    nl_NL: 'categorie',
    it_IT: 'categoria',
    es_ES: 'categoria',
    th_TH: 'หมวดหมู่',
    id_ID: 'k',
    el_GR: 'k',
    tr_TR: 'k',
    en_US: 'c',
    fr_FR: 'c',
    pt_BR: 'c',
    ru_RU: 'c',
    pl_PL: 'c',
    ro_RO: 'c',
    de_DE: 'c',
    nb_NO: 'c',
    sv_SE: 'c',
    fi_FI: 'c',
    uk_UA: 'c',
    da_DK: 'c',
    cs_CZ: 'c',
    hu_HU: 'c',
    ar_SA: 'c',
    vi_VN: 'c',
    ko_KR: 'c',
    ja_JP: 'c',
};
const localeToTagPrefix = {
    nl_NL: 'tag',
    it_IT: 'tipo',
    es_ES: 'e',
    el_GR: 'e',
    tr_TR: 'e',
    th_TH: 'แท็ก',
    en_US: 't',
    id_ID: 't',
    fr_FR: 't',
    pt_BR: 't',
    ru_RU: 't',
    pl_PL: 't',
    ro_RO: 't',
    de_DE: 't',
    nb_NO: 't',
    sv_SE: 't',
    fi_FI: 't',
    uk_UA: 't',
    da_DK: 't',
    cs_CZ: 't',
    hu_HU: 't',
    ar_SA: 't',
    vi_VN: 't',
    ko_KR: 't',
    ja_JP: 't',
};
const localeToGamePrefix = {
    nl_NL: 'spel',
    it_IT: 'gioco',
    es_ES: 'juego',
    fr_FR: 'jeu',
    pt_BR: 'jogos',
    ru_RU: 'igra',
    de_DE: 'spiele',
    fi_FI: 'peli',
    nb_NO: 'spill',
    pl_PL: 'gra',
    ro_RO: 'joc',
    sv_SE: 'spel',
    uk_UA: 'gra',
    el_GR: 'paixnidi',
    da_DK: 'spil',
    cs_CZ: 'hra',
    hu_HU: 'jatek',
    tr_TR: 'oyun',
    vi_VN: 'trò-chơi',
    th_TH: 'เกม',
    ko_KR: '게임',
    en_US: 'game',
    id_ID: 'game',
    ar_SA: 'game',
    ja_JP: 'game',
};
const localeToProdDomainDetails = {
    en_US: {
        base: `https://www.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    nl_NL: {
        base: `https://www.crazygames.nl`,
        pathname: '',
        domain: 'crazygames.nl',
    },
    it_IT: {
        base: `https://it.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    es_ES: {
        base: `https://www.crazygames.com`,
        pathname: '/es',
        domain: 'crazygames.com',
    },
    id_ID: {
        base: `https://www.crazygames.co.id`,
        pathname: '',
        domain: 'crazygames.co.id',
    },
    fr_FR: {
        base: `https://www.crazygames.fr`,
        pathname: '',
        domain: 'crazygames.fr',
    },
    pt_BR: {
        base: `https://www.crazygames.com.br`,
        pathname: '',
        domain: 'crazygames.com.br',
    },
    ru_RU: {
        base: `https://www.crazygames.ru`,
        pathname: '',
        domain: 'crazygames.ru',
    },
    de_DE: {
        base: `https://de.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    pl_PL: {
        base: `https://www.crazygames.pl`,
        pathname: '',
        domain: 'crazygames.pl',
    },
    ro_RO: {
        base: `https://www.crazygames.ro`,
        pathname: '',
        domain: 'crazygames.ro',
    },
    nb_NO: {
        base: `https://www.crazygames.no`,
        pathname: '',
        domain: 'crazygames.no',
    },
    sv_SE: {
        base: `https://www.crazygames.se`,
        pathname: '',
        domain: 'crazygames.se',
    },
    fi_FI: {
        base: `https://www.crazygames.fi`,
        pathname: '',
        domain: 'crazygames.fi',
    },
    uk_UA: {
        base: `https://www.crazygames.com.ua`,
        pathname: '',
        domain: 'crazygames.com.ua',
    },
    el_GR: {
        base: `https://gr.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    da_DK: {
        base: `https://www.crazygames.com`,
        pathname: '/dk',
        domain: 'crazygames.com',
    },
    cs_CZ: {
        base: `https://www.crazygames.cz`,
        pathname: '',
        domain: 'crazygames.cz',
    },
    hu_HU: {
        base: `https://www.crazygames.hu`,
        pathname: '',
        domain: 'crazygames.hu',
    },
    tr_TR: {
        base: `https://www.crazygames.com`,
        pathname: '/tr',
        domain: 'crazygames.com',
    },
    ar_SA: {
        base: `https://ar.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    vi_VN: {
        base: `https://vn.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    th_TH: {
        base: `https://th.crazygames.com`,
        pathname: '',
        domain: 'crazygames.com',
    },
    ko_KR: {
        base: `https://www.crazygames.co.kr`,
        pathname: '',
        domain: 'crazygames.co.kr',
    },
    ja_JP: {
        base: `https://www.crazygames.com`,
        pathname: '/jp',
        domain: 'crazygames.com',
    },
};
const localeToDevDomainDetails = {
    en_US: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    nl_NL: {
        base: `https://nl-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    it_IT: {
        base: `https://it-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    es_ES: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/es',
        domain: 'dev-crazygames.be',
    },
    id_ID: {
        base: `https://id-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    fr_FR: {
        base: `https://fr-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    pt_BR: {
        base: `https://br-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ru_RU: {
        base: `https://ru-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    de_DE: {
        base: `https://de-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    pl_PL: {
        base: `https://pl-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ro_RO: {
        base: `https://ro-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    nb_NO: {
        base: `https://no-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    sv_SE: {
        base: `https://se-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    fi_FI: {
        base: `https://fi-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    uk_UA: {
        base: `https://uk-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    el_GR: {
        base: `https://gr-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    da_DK: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/dk',
        domain: 'dev-crazygames.be',
    },
    cs_CZ: {
        base: `https://cz-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    hu_HU: {
        base: `https://hu-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    tr_TR: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/tr',
        domain: 'dev-crazygames.be',
    },
    ar_SA: {
        base: `https://ar-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    vi_VN: {
        base: `https://vn-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    th_TH: {
        base: `https://th-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ko_KR: {
        base: `https://kr-portal.dev-crazygames.be`,
        pathname: '',
        domain: 'dev-crazygames.be',
    },
    ja_JP: {
        base: `https://portal.dev-crazygames.be`,
        pathname: '/jp',
        domain: 'dev-crazygames.be',
    },
};
function getLocaleCategoryPrefix(locale) {
    const prefix = localeToCategoryPrefix[locale];
    if (!(0, isDefined_1.isDefined)(prefix)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return prefix;
}
function getLocaleTagPrefix(locale) {
    const prefix = localeToTagPrefix[locale];
    if (!(0, isDefined_1.isDefined)(prefix)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return prefix;
}
function getLocaleGamePrefix(locale) {
    const prefix = localeToGamePrefix[locale];
    if (!(0, isDefined_1.isDefined)(prefix)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return prefix;
}
function getLocaleDomainDetails(locale, environment) {
    const domainDetails = getLocaleDomainRecord(environment)[locale];
    if (!(0, isDefined_1.isDefined)(domainDetails)) {
        //If our types are correct, we should never get here
        //However, those Locales are a manual list.
        //In case we ever forget to update that list, we want to fail fast
        throw new Error(`Locale ${locale} not supported`);
    }
    return domainDetails;
}
function getLocaleDomainRecord(environment) {
    switch (environment) {
        case 'dev':
            return localeToDevDomainDetails;
        case 'prod':
            return localeToProdDomainDetails;
    }
}
function getLocaleDomain(locale) {
    const localeProdDomainDetails = getLocaleDomainDetails(locale, 'prod');
    return `${localeProdDomainDetails.base}${localeProdDomainDetails.pathname}`;
}
